import { useContext, useState, useEffect } from "react";
import BannerHome from "./BannerHome/BannerHome";
import MetaData from "../../Components/MetaData/MetaData";
import { useNavigate } from "react-router-dom";
import './Home.css';
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import heroWhale from "../../Assets/Images/whalesai-new/banner-bg.png";
import users from "../../Assets/Images/whalesai-new/icons/social.PNG";
import support from "../../Assets/Images/whalesai-new/icons/support.PNG";
import document from "../../Assets/Images/whalesai-new/icons/document.PNG";
import star from "../../Assets/Images/whalesai-new/icons/star.PNG";
import { FaArrowRight } from "react-icons/fa";


const benefits = [
    {
        title: 'Cost Efficiency',
        desc: 'Pay-per-use model saves you money. Only pay for what you generate.',
        icon: '💰',
        colorClass: 'home-benefit-icon-blue',
    },
    {
        title: 'Creative Freedom',
        desc: 'Use AI to generate unique content ideas, captions, and visuals tailored to your brand.',
        icon: '🎨',
        colorClass: 'home-benefit-icon-green',
    },
    {
        title: 'Time Savings',
        desc: 'Generate high-quality content in seconds, not hours.',
        icon: '⏱️',
        colorClass: 'home-benefit-icon-orange',
    },
    {
        title: 'Quality & Consistency',
        desc: 'Maintain a consistent brand voice and high-quality output every time.',
        icon: '✅',
        colorClass: 'home-benefit-icon-purple',
    },
    {
        title: 'Scalability',
        desc: 'From one post to hundreds, scale your content creation effortlessly.',
        icon: '📈',
        colorClass: 'home-benefit-icon-cyan',
    },
    {
        title: 'Innovation',
        desc: 'Stay ahead with AI-powered ideas and the latest content trends.',
        icon: '💡',
        colorClass: 'home-benefit-icon-red',
    },
    {
        title: 'Accessibility',
        desc: 'User-friendly platform for beginners and pros alike.',
        icon: '🌐',
        colorClass: 'home-benefit-icon-teal',
    },
    {
        title: 'Support & Improvement',
        desc: 'We continuously improve and offer support whenever you need it.',
        icon: '🛠️',
        colorClass: 'home-benefit-icon-indigo',
    },
];

const stats = [
    { icon: users, number: '1000+', label: 'Happy Creators', color: "#A573DE" },
    { icon: document, number: '10M+', label: 'Content Generated', color: "#A573DE" },
    { icon: star, number: '98%', label: 'Satisfaction Rate', color: "#3CA8E7" },
    { icon: support, number: '24/7', label: 'AI Support', color: "#3CA8E7" },
];

const heroImages = ["/win2singapore.png", heroWhale];

const HomeNew = () => {
    const navigate = useNavigate();
    const { AIUser } = useContext(UserAuthContext);

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isImageVisible, setIsImageVisible] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsImageVisible(false);

            setTimeout(() => {
                setCurrentImageIndex(
                    (prevIndex) => (prevIndex + 1) % heroImages.length
                );
                setIsImageVisible(true);
            }, 500);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const handleCtaClick = () => {
        if (AIUser) {
            navigate('/dashboard');
        } else {
            navigate('/sign-up');
        }
    };

    return (
        <div className="home-page">
            <MetaData
                pageTitle={
                    "Smart Social Media Management AI Platform | AI Post Generator"
                }
                pageDescription={
                    "Upgrade your social media presence with our top-rated social media management AI platform that delivers the best AI-generated posts. Sign up now!"
                }
                canonical="https://whalesai.com/"
            ></MetaData>

            {/* Promo Banner */}
            <div className="home-promo-banner">
                <div className="home-promo-banner-inner" onClick={handleCtaClick}>
                    {/* <span className="home-promo-banner-icon">🎁</span> */}
                    <p className="home-promo-banner-text">
                        Sign up today and receive <span style={{ fontWeight: "bold", color: "#3CA8E7" }}> 250 credits</span> to start creating content!
                    </p>
                </div>
            </div>

            {/* Hero Section */}
            <section className="home-hero">
                <div className="home-hero-container">
                    <div className="home-hero-content">
                        <h1 className="home-hero-title">
                            <span className="home-hero-title-white">Create. Publish. Grow.</span>
                            <span className="home-hero-title-gradient">All with WhalesAI.</span>
                        </h1>
                        <p className="home-hero-description">
                            The all-in-one AI workspace for content creators, marketers &amp; businesses.
                        </p>
                        <div className="home-hero-buttons">
                            <button className="home-hero-btn-primary" onClick={handleCtaClick}>
                                Get Started Free
                                <span className="home-hero-btn-icon"><FaArrowRight /></span>
                            </button>
                            <button
                                className="home-hero-btn-secondary"
                                onClick={() => navigate("/how-it-works")}
                            >
                                See How It Works
                                <span className="home-hero-play-icon">▶</span>
                            </button>
                        </div>
                        <div className="home-hero-trust-badges">
                            <span className="home-hero-trust-badge">
                                <span className="home-hero-trust-check">✓</span> No subscription
                            </span>
                            <span className="home-hero-trust-badge">
                                <span className="home-hero-trust-check">✓</span> No commitments
                            </span>
                            <span className="home-hero-trust-badge">
                                <span className="home-hero-trust-check">✓</span> Pay for what you generate
                            </span>
                        </div>
                    </div>
                    <div className="home-hero-image" onClick={handleCtaClick} style={{ cursor: "pointer" }}>
                        <img
                            src={heroImages[currentImageIndex]}
                            alt="WhalesAI - AI Content Creation Platform"
                            className={`home-hero-image-img ${isImageVisible ? "home-hero-image-visible" : "home-hero-image-hidden"
                                }`}
                        />
                    </div>
                </div>
            </section>

            {/* AI Tools Swiper (BannerHome component) */}
            <div className="home-swiper-section">
                <BannerHome />
            </div>

            {/* Social Media Bar */}
            <div className="home-social-bar">
                <div className="home-social-bar-container">
                    <div className="home-social-bar-left">
                        <span className="home-social-bar-icon">🤖</span>
                        <p className="home-social-bar-text">
                            Find out how you can create content for your <strong>social media channels</strong>.
                        </p>
                    </div>
                    <button
                        className="home-social-bar-btn"
                        onClick={() => navigate("/do-it-yourself")}
                    >
                        Explore All Tools
                        <span>→</span>
                    </button>
                </div>
            </div>

            {/* Stats Section */}
            <section className="home-stats">
                <div className="home-stats-container">
                    {stats.map((stat, index) => (
                        <div className="home-stat-card" key={index}>
                            <div className="home-stat-icon">
                                <img src={stat.icon} alt={stat.label} />
                            </div>

                            <div className="home-stat-content">
                                <div
                                    className="home-stat-number"
                                    style={{ color: stat.color }}
                                >{stat.number}</div>
                                <div className="home-stat-label">{stat.label}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Benefits Section */}
            <section className="home-benefits">
                <div className="home-benefits-container">
                    {benefits.map((benefit, index) => (
                        <div className="home-benefit-card" key={index}>
                            <div className="home-benefit-header">
                                <div className={`home-benefit-icon-wrapper ${benefit.colorClass}`}>
                                    {benefit.icon}
                                </div>
                                <h3 className="home-benefit-title">{benefit.title}</h3>
                            </div>
                            <p className="home-benefit-desc">{benefit.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

        </div>
    );
};

export default HomeNew;
